'use client';

import React, { memo, useId, useState } from 'react';
import styles from './Accordion.module.css';

export type AccordionItem = {
  question: string;
  answer: string;
};

export const Accordion = memo(function Accordion({ items, variant }: { items: AccordionItem[]; variant?: 'default' | 'seo' }) {
  const baseId = useId();
  const [openIdx, setOpenIdx] = useState<number>(0);
  const wrapClass = variant === 'seo' ? `${styles.wrap} ${styles.wrapSeo}` : styles.wrap;

  return (
    <div className={wrapClass}>
      {items.map((it, idx) => {
        const isOpen = idx === openIdx;
        const contentId = `${baseId}-${idx}-content`;
        return (
          <div key={it.question} className={`${styles.item} ${variant === 'seo' ? styles.itemSeo : ''}`}>
            <button
              className={`${styles.btn} ${variant === 'seo' ? styles.btnSeo : ''}`}
              onClick={() => setOpenIdx(isOpen ? -1 : idx)}
              aria-expanded={isOpen}
              aria-controls={contentId}
              type="button"
            >
              <p className={styles.q}>{it.question}</p>
              <span className={`${styles.icon} ${variant === 'seo' ? styles.iconSeo : ''}`} aria-hidden="true">
                {isOpen ? '−' : '+'}
              </span>
            </button>
            {isOpen ? (
              <div id={contentId} className={`${styles.panel} ${variant === 'seo' ? styles.panelSeo : ''}`}>
                {it.answer}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
});
